// src/redux/services/selectionsService/selections.Services.js
import { baseApi } from "../baseApi";

export const SelectionsApi = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        // ============================
        // CREATE SELECTION
        // ============================
        createSelection: builder.mutation({
            query: (data) => ({
                url: "/selection",
                method: "POST",
                body: data,
            }),
            invalidatesTags: ["Selections"],
        }),

        // ============================
        // GET ALL SELECTIONS
        // ============================
        getSelections: builder.query({
            query: ({
                page = 1,
                limit = 10,
                search = "",
                type = "",
                waad_id = "",
                status = "",
                sport_name = "",
                sport_level = "",
                job_type = "",
                job_department = "",
            } = {}) => {
                let url = `/selections?page=${page}&limit=${limit}`;
                if (search) url += `&search=${search}`;
                if (type) url += `&type=${type}`;
                if (waad_id) url += `&waad_id=${waad_id}`;
                if (status) url += `&status=${status}`;
                if (sport_name) url += `&sport_name=${sport_name}`;
                if (sport_level) url += `&sport_level=${sport_level}`;
                if (job_type) url += `&job_type=${job_type}`;
                if (job_department) url += `&job_department=${job_department}`;
                return url;
            },
            providesTags: ["Selections"],
        }),

        // ============================
        // GET SELECTION STATS
        // ============================
        getSelectionStats: builder.query({
            query: () => "/selection-stats",
            providesTags: ["Selections"],
        }),

        // ============================
        // GET SINGLE SELECTION
        // ============================
        // src/redux/services/selectionsService/selections.Services.js

        // GET SINGLE SELECTION
        getSelectionById: builder.query({
            query: (id) => `/selection/${id}`,
            providesTags: (result, error, id) => [{ type: "Selections", id }],
        }),

        // UPDATE SELECTION
        updateSelection: builder.mutation({
            query: ({ id, data }) => ({
                url: `/selection/${id}`,
                method: "PUT",
                body: data,
            }),
            invalidatesTags: ["Selections"],
        }),

      

        // ============================
        // CHANGE SELECTION STATUS
        // ============================
        changeSelectionStatus: builder.mutation({
            query: ({ id, status }) => ({
                url: `/selection-status/${id}`,
                method: "PATCH",
                body: { status },
            }),
            invalidatesTags: ["Selections"],
        }),

        // ============================
        // DELETE SELECTION
        // ============================
        deleteSelection: builder.mutation({
            query: (id) => ({
                url: `/selection/${id}`,
                method: "DELETE",
            }),
            invalidatesTags: ["Selections"],
        }),
    }),
});

export const {
    useCreateSelectionMutation,
    useGetSelectionsQuery,
    useGetSelectionStatsQuery,
    useGetSelectionByIdQuery,
    useUpdateSelectionMutation,
    useChangeSelectionStatusMutation,
    useDeleteSelectionMutation,
} = SelectionsApi;